<script>
    export let width100 = false;
</script>

<button class:arsize_btn-width-100={width100} class="arsize_btn" on:click>
    <slot name="icon"></slot>
    <span class="arsize_btn_span">
        <slot name="text"></slot>
    </span>
</button>

<style>
    button {
        box-sizing: border-box;
    }
    .arsize_btn {
        outline: none;
        padding: 21px 66px;
        font-size: 20px;
        line-height: 20px;
        color: #fff;
        border-radius: 8px;
        border: 0;
        position: relative;
        min-width: 268px;
        overflow: hidden;
        display: flex;
        cursor: pointer;
        justify-content: center;
        background-color: #777;
    }
    .arsize_btn_span {
        display: block;
        align-self: center;
    }
    .arsize_btn-width-100 {
        width: 100%;
        display: block;
        text-align: center;
        padding-left: 0;
        padding-right: 0;
    }
    .arsize_btn:hover,
    .arsize_btn:focus {
        outline: none;
        border: 0;
        color: #fff;
        transition: color .1s ease-out, background-color 0s ease-out .1s;
        box-shadow: none;
    }
    .arsize_btn:active {
        outline: none;
        border: 0;
        color: #fff;
        transition: color .1s ease-out, background-color 0s ease-out .1s;
        box-shadow: none;
    }
    :global(.arsize_color_green) .arsize_btn {
        background-color: #4CC499;
    }
    :global(.arsize_color_green) .arsize_btn:hover,
    :global(.arsize_color_green) .arsize_btn:focus {
        background-color: #23B17E;
    }
    :global(.arsize_color_green) .arsize_btn:active {
        background-color: #0A9A66;
    }
    @media (max-width: 1279.98px) {
        .arsize_btn {
            padding: 18px 0;
            font-size: 18px;
            line-height: 18px;
            border-radius: 8px;
            min-width: 268px;
            justify-content: center;
        }
    }
</style>